module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 36
// module chunks = 0